import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();
  
  const handleClick = async () => {
    try {
      const response = await axios.post('http://localhost:5001/api/it-is-live');
      console.log(response.data); // Log the response to confirm the API call
    } catch (error) {
      console.error('Error fetching from /api/it-is-live:', error);
    }
  };

  const goToReleaseNotes = () => {
    navigate('/release-notes');
  };

  const goToConsumption = () => {
    navigate('/consumption');
  };


  return (
    <div className="flex justify-center items-center h-screen">
      <button
        onClick={handleClick}
        className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition duration-300"
      >
        It Is Live!
      </button>
      <button onClick={goToReleaseNotes}
      className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition duration-300"
      >
        Release Notes
      </button>
      <button onClick={goToConsumption}
      className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-700 transition duration-300"
      >
        Consumption
      </button>
    </div>
  );
};

export default Landing;